import * as React from "react";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { ApplicationState } from "../../../applicationState";

import { loadTaskTypes } from "../../../tasks/actions";

import { CloseTaskAndCreateFollowUpTaskModal } from "./CloseTaskAndCreateFollowUpTaskModal";

export const ActionGeneralTaskModal = () => {
    const dispatch = useDispatch();
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const customerId = useSelector((state: ApplicationState) => state.router.params?.customerId);

    React.useEffect(() => {
        dispatch(loadTaskTypes(customerId, ohCaseId));
    }, [customerId, dispatch, ohCaseId]);

    return <CloseTaskAndCreateFollowUpTaskModal />;
};
